import React from 'react';
import {connect} from 'react-redux';
import { Table } from 'react-bootstrap';

class WasteDataPane extends React.Component {
  constructor() {
    super();
  }
  render() {
    if((this.props.loadingData)&&(this.props.loadingData.total)
      &&(this.props.loadingData.loaded)&&(this.props.loadingData.loaded.size
        !== this.props.loadingData.total)&&this.props.isLoading) {
      return <div>
        Loading
      </div>;
    }
    if((this.props.currentFeature)&&(this.props.currentFeature.properties)
      &&(this.props.currentFeature.properties.wasteData)) {
        let data = this.props.currentFeature.properties.wasteData;
      return <div className="h6">
        <dl>
          <dt>
            Type
          </dt>
          <dd>
            {data["type"]}
          </dd>
          <dt>
            Address
          </dt>
          <dd>
            {data["address"]}
          </dd>
        </dl>
      </div>;
    }
    return <div>
      No waste related information available for this area
    </div>;
  }
}

export default connect((state) => {
  return {
    currentFeature: state.governanceData.currentFeature,
    isLoading: state.governanceData.isLoading,
    loadComplete: state.governanceData.loadComplete,
    loadingData: state.governanceData.loadingData
  };
})(WasteDataPane);



// WEBPACK FOOTER //
// ./src/components/waste/Pane.js